import moment from 'moment';

const daysBeforeToFilter = -14;

// If no start time filter currently present,
// set default filter to 2 weeks before current time
export function getDefaultStartTime(): Date {
  return moment().add(daysBeforeToFilter, 'day').startOf('day').toDate();
}
